// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1kMmF","buttons":"styles_buttons__357SD"};